import * as React from 'react';
import styles from './MapWithInfo.module.css';

const MapWithInfo = ({ info, children }) => (
  <div className={styles.MapWithInfo}>
    {info && (
      <div className={styles.MapWithInfoBox}>
        <p>{info}</p>
      </div>
    )}
    {children}
  </div>
);

export default MapWithInfo;
